/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Button,
  ButtonGroup,
  ButtonToolbar
} from "shards-react";
import differenceBy from "lodash/differenceBy";
import PageTitle from "../components/common/PageTitle";
import BasicModalExample from "./Modal";

class BlogPosts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      UserisAdmin: false,
      PostsListOne: [
        {
          backgroundImage: require("../images/content-management/marroco.jpg"),
          category: "Africa",
          categoryTheme: "dark",
          author: "Nathan Drake",
          authorAvatar: require("../images/avatars/1.jpg"),
          title: "My best travel in Marocco",
          body:
            "Traveling Morocco is an intense experience.It’s chaotic. It’s colorful. It’s fragrant. It’s eye-opening. It’s an in your face sensory overload that travelers either love or hate.",
          date: "28 February 2019"
        },
        {
          backgroundImage: require("../images/content-management/2.jpeg"),
          category: "Europe",
          categoryTheme: "info",
          author: "Daniel Perez",
          authorAvatar: require("../images/avatars/2.jpg"),
          title: "200 $ for 3 nights in Greece",
          body:
            "Although the news has been full of negative stories about the financial and immigrant crises which have engulfed Greece in recent years, there are still many reasons to visit. ",
          date: "29 February 2019"
        },
        {
          backgroundImage: require("../images/content-management/3.jpeg"),
          category: "Middle east",
          categoryTheme: "warning",
          author: "Jimmy Jackson",
          authorAvatar: require("../images/avatars/2.jpg"),
          title: "Visit Pyramid of Giza in Egypt",
          body:
            "Hi, I will be Cairo together with my wife early next month. Since our time in Cairo is very limited, we hope to do a half day tour of the Giza Pyramids arranged by Emo Tours.",
          date: "29 February 2019"
        },
        {
          backgroundImage: require("../images/content-management/telaviv.jpg"),
          category: "Middle east",
          categoryTheme: "warning",
          author: "John James",
          authorAvatar: require("../images/avatars/3.jpg"),
          title: "Book your trip at Nahalat Benyamin Tel Aviv ",
          body:
            "Tel Aviv is the best place to be especially for the beautiful John Brice LTD office.",
          date: "29 February 2019"
        }
      ],
      PostsListTwo: []
    };
  }
  async componentDidMount() {
    let PostsListOne = this.state.PostsListOne;
    let PostsListTwo = this.state.PostsListTwo;
    let VacationNotFollowed = this.state.PostsListTwo;
    console.log(PostsListOne);
    let UserID = sessionStorage.getItem("userID");
    let ObjectUserID = { UserID: UserID };
    var ObjectUserIDString = JSON.stringify(ObjectUserID);

    try {
      const response = await fetch(
        "https://expressgenetator.herokuapp.com/users"
      );
      PostsListOne = await response.json();
      const fallowedPost = await fetch(
        "https://expressgenetator.herokuapp.com/users/fallowedlisting",
        {
          method: "POST",
          body: ObjectUserIDString,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }
      );
      console.log("this is userid", UserID);
      PostsListTwo = await fallowedPost.json();
      console.log("This is my FUCKINGGGG DATA", PostsListTwo);
    } finally {
      const VacationNotFollowed = differenceBy(
        PostsListOne,
        PostsListTwo,
        "body"
      );
      this.setState({
        PostsListOne: PostsListTwo,
        PostsListTwo: VacationNotFollowed
      });

      this.OnSecurityCheck();
      console.log(this.state.PostsListOne);
    }
  }

  OnSecurityCheck = async data => {
    var check = Number(sessionStorage.getItem("userID"));
    var idsecurity = {
      id: check
    };

    var ben = JSON.stringify(idsecurity);
    console.log(idsecurity);
    const response = await fetch(
      `https://expressgenetator.herokuapp.com/users/security`,
      {
        method: "POST",
        body: ben,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }
    );

    if (response.status === 200) {
      this.setState({
        UserisAdmin: true
      });
      console.log("User is admin !");
    } else {
      console.error("You are not admin of this website");
      this.setState({
        UserisAdmin: false
      });
      console.log("User is NOT admin !");
    }
  };

  OnFallow = async data => {
    console.log("this is the trip fallowed", data)
    var thefallow = {
      id : data, 
      Userid : sessionStorage.getItem("userID")
    }
    var FallowTrip = JSON.stringify(thefallow);
    console.log("this is FallowTrip", FallowTrip);
    const response = await fetch(
      `https://expressgenetator.herokuapp.com/users/fallow`,
      {
        method: "POST",
        body: FallowTrip,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }
    );

    if (response.status === 200) {
      console.log("The new user fallowed the trip");
      this.componentDidMount();
    } else {
      console.error("You can not Fallow this trip");
    }
  };

  OnUnFallow = async data => {
    data.Userid = sessionStorage.getItem("userID");
    var FallowTrip = JSON.stringify(data);
    console.log("this is FallowTrip", FallowTrip);
    const response = await fetch(
      `https://expressgenetator.herokuapp.com/users/unfallow`,
      {
        method: "POST",
        body: FallowTrip,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }
    );

    if (response.status === 200) {
      console.log("The new user fallowed the trip");
      this.componentDidMount();
    } else {
      console.error("You can not Fallow this trip");
    }
  };

  OnDelete = async data => {
    var DeletedTrip = JSON.stringify(data);
    console.log("User tried to delete this trip", DeletedTrip);
    const response = await fetch(
      `https://expressgenetator.herokuapp.com/users/deletetrip`,
      {
        method: "POST",
        body: DeletedTrip,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }
    );

    if (response.status === 200) {
      console.log(`This trip ${DeletedTrip.id} has been deleted`);
      this.componentDidMount();
    } else {
      console.error(
        "The server didn't accept your delete, it's very strange, don't try to hack us"
      );
    }
  };

  render() {
    const { PostsListOne, PostsListTwo } = this.state;

    return (
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title="Welcome to My Expedia"
            subtitle="Socialize your trip with us"
            className="text-sm-left"
          />
        </Row>

        {/* First Row of Posts */}
        <Row>
          {PostsListOne.map((post, idx) => (
            <Col lg="3" md="6" sm="12" className="mb-4" key={idx}>
              <Card small className="card-post card-post--1">
                <div
                  className="card-post__image"
                  style={{ backgroundImage: `url(${post.backgroundImage})` }}
                >
                  <Badge
                    pill
                    className={`card-post__category bg-${post.categoryTheme}`}
                  >
                    {post.category}
                  </Badge>
                  <div className="card-post__author d-flex">
                    <a
                      href="#"
                      className="card-post__author-avatar card-post__author-avatar--small"
                      style={{ backgroundImage: `url('${post.authorAvatar}')` }}
                    >
                      Written by {post.author}
                    </a>
                  </div>
                </div>
                <CardBody>
                  <h5 className="card-title">
                    <a href="#" className="text-fiord-blue">
                      {post.title}
                    </a>
                  </h5>
                  <p className="card-text d-inline-block mb-3">{post.body}</p>
                  <span className="text-muted">{post.date}</span>
                  <span className="text-muted">
                    Written by {post.author}
                  </span>{" "}
                  <br />
                  <Button
                    onClick={() => this.OnUnFallow(post)}
                    size="sm"
                    theme="white"
                  >
                    <i className="far fa-bookmark mr-1" /> Fallowed ✔{" "}
                    {post.followers}
                  </Button>
                  {this.state.UserisAdmin && (
                    <ButtonToolbar>
                      <ButtonGroup size="sm">
                        <Button
                          theme="danger"
                          onClick={() => this.OnDelete(post)}
                        >
                          Delete
                        </Button>
                        <BasicModalExample id={post.id} author={post.author} title={post.title} />
                      </ButtonGroup>
                    </ButtonToolbar>
                  )}
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Second Row of Posts */}
        <Row>
          {PostsListTwo.map((post, idx) => (
            <Col lg="6" sm="12" className="mb-4" key={idx}>
              <Card small className="card-post card-post--aside card-post--1">
                <div
                  className="card-post__image"
                  style={{ backgroundImage: `url('${post.backgroundImage}')` }}
                >
                  <Badge
                    pill
                    className={`card-post__category bg-${post.categoryTheme}`}
                  >
                    {post.category}
                  </Badge>
                  <div className="card-post__author d-flex">
                    <a
                      href="#"
                      className="card-post__author-avatar card-post__author-avatar--small"
                      style={{ backgroundImage: `url('${post.authorAvatar}')` }}
                    >
                      Written by Anna Ken
                    </a>
                  </div>
                </div>
                <CardBody>
                  <h5 className="card-title">
                    <a className="text-fiord-blue" href="#">
                      {post.title}
                    </a>
                  </h5>
                  <p className="card-text d-inline-block mb-3">{post.body}</p>
                  <span className="text-muted">{post.date}</span>
                  <Button
                    onClick={() => this.OnFallow(post.id)}
                    size="sm"
                    theme="white"
                  >
                    <i className="far fa-bookmark mr-1" /> Fallow{" "}
                    {post.followers}
                  </Button>
                  <ButtonToolbar>
                    {this.state.UserisAdmin && (
                      <ButtonGroup size="sm">
                        <Button
                          theme="danger"
                          onClick={() => this.OnDelete(post)}
                        >
                          Delete
                        </Button>
                        <BasicModalExample></BasicModalExample>
                      </ButtonGroup>
                    )}
                  </ButtonToolbar>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    );
  }
}

export default BlogPosts;
